module.exports = __webpack_public_path__ + "static/dog-avatar-16fa9733ece62267361571061533df42.svg";